function questionLabelDirective() {
    'ngInject';

    return {
        transclude: false,
        restrict: 'A',
        scope: false,
        link(scope, element, attrs) {
            scope.$watch(attrs.bbQuestionLabel, (question) => {
                if (question) {
                    if ((question.detail_type === 'check') || (question.detail_type === 'check-price')) {
                        return element.html('');
                    }
                }
            });
        }
    };
}

angular
    .module('BB.inputs')
    .directive('bbQuestionLabel', questionLabelDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/question-label/question_label.directive.js